export class EntityListBuilder {
  #list;

  constructor() {
    this.#list = [];
  }

  addItem = (data) => {
    this.#list.push(data);
    return this;
  };

  getList = () => {
    return this.#list;
  };
}
